import React from 'react';
import { connect } from 'react-redux';
import { Button } from '@mui/material';
import UploadView from '../upload/UploadView';
import {
  uploadBuildingImageActionCreator,
  patchBuildingActionCreator,
} from '../../redux/actions/buildings';

const INITIAL_STATE = {
  selectedFile: null,
  selectedFilename: '',
};

class ImageUpload extends React.PureComponent {
  state = INITIAL_STATE;

  onFileSelection(e) {
    e.preventDefault();
    if (e.target.files.length !== 1) return;
    const file = e.target.files[0];
    this.setState({ selectedFile: file, selectedFilename: file.name });
  }

  reset() {
    this.setState(INITIAL_STATE);
  }

  formSubmit() {
    const { imageUpload } = this.props;
    const { selectedFile } = this.state;
    if (selectedFile == null) return;
    imageUpload(selectedFile).then(() => this.reset());
  }

  render() {
    const {
      building: { imgSrc, name },
      removeThumbnail,
    } = this.props;
    const { selectedFilename } = this.state;
    return (
      <>
        {imgSrc && <img style={{ width: '300px' }} src={imgSrc} alt={name} />}
        {imgSrc && (
          <Button variant="contained" color="primary" onClick={() => removeThumbnail()}>
            Remove Thumbnail
          </Button>
        )}
        <UploadView
          showUploadButton={selectedFilename !== ''}
          onFileSelection={(f) => this.onFileSelection(f)}
          selectedFileName={this.state.selectedFilename}
          onFormSubmit={() => this.formSubmit()}
          isLoading={false}
        />
      </>
    );
  }
}

export default connect(null, (dispatch, { building: { id } }) => ({
  imageUpload: (image) => dispatch(uploadBuildingImageActionCreator(id, image)),
  removeThumbnail: () => dispatch(patchBuildingActionCreator(id, { img_src: 'REMOVE' })),
}))(ImageUpload);
